<div
  class="row section clinical-feedback-section mt-3"
  formGroupName="feedback"
>
  <div class="section-container">
    <div class="row section-row">
      <div class="col section-col">
        <h5 class="section-heading">Feedback</h5>
        <p>
          Use the form to provide clinical feedback on cases reported by
          Everlight.
          <span *ngIf="showAnz">
            For any operations queries or IT queries, call us (AU: 1800 705
            402/NZ: 0800 001 430) or email
            <a href="mailto:operations@everlightradiology.com"
              >operations&#64;everlightradiology.com</a
            >.
          </span>
          <span *ngIf="showUki">
            For any IT queries call us on 0300 400 1930. For any operations
            queries call us on 0300 400 2222 or 0300 400 1111 or email
            <a href="mailto:help@everlightradiology.com"
              >help&#64;everlightradiology.com</a
            >.
          </span>
        </p>
      </div>
    </div>
    <div class="row section-row">
      <div class="col-3 section-col">
        <app-dropdown
          [id]="formElementModels['feedbackType'].id"
          [formElementModel]="formElementModels['feedbackType']"
          [parentFormGroup]="formGroup"
        ></app-dropdown>
      </div>
      <div class="col-3 section-col" *ngIf="showSeverityLevelDropdown">
        <app-dropdown
          [id]="formElementModels['severityLevel'].id"
          [formElementModel]="formElementModels['severityLevel']"
          [parentFormGroup]="formGroup"
        ></app-dropdown>
      </div>
      <div class="col-3 section-col">
        <app-dropdown
          *ngIf="showSeriousIncidentType"
          [id]="formElementModels['seriousIncidentType'].id"
          [formElementModel]="formElementModels['seriousIncidentType']"
          [parentFormGroup]="formGroup"
        ></app-dropdown>
      </div>
      <div class="col-3 section-col">
        <app-text
          *ngIf="showRegulatoryInvestigationType"
          [id]="formElementModels['regulatoryInvestigationType'].id"
          [formElementModel]="formElementModels['regulatoryInvestigationType']"
          [parentFormGroup]="formGroup"
        ></app-text>
      </div>
    </div>
    <div class="row section-row">
      <div class="col section-col">
        <app-rich-text-editor
          [id]="formElementModels['feedbackDetails'].id"
          [formElementModel]="formElementModels['feedbackDetails']"
          [parentFormGroup]="formGroup"
        ></app-rich-text-editor>
      </div>
    </div>
    <div class="row section-row">
      <div class="col section-col">
        <app-rich-text-editor
          [id]="formElementModels['clinicalImpactDetails'].id"
          [formElementModel]="formElementModels['clinicalImpactDetails']"
          [parentFormGroup]="formGroup"
        ></app-rich-text-editor>
      </div>
    </div>
  </div>
</div>
